/* import __COLOCATED_TEMPLATE__ from './mass-start-timing-seedgroup-association-table.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import dayjs from 'dayjs';

export default class MassStartTimingSeedGroupAssociationTableComponent extends Component 
{
	@service store;
	@service ajax;
	
	@tracked selectedSeedGroup = null;
	@tracked seedGroups = null;
	
	get clearDisabled()
	{
		return this.args.selectedStartImpulse == null;
	}
	get associateDisabled()
	{
		return this.args.selectedStartImpulse == null;
	}
	
	@action
	populateSeedGroups()
	{
		if (!this.args.event) {
			return;
		}
		var that = this;
		this.args.event.get('entries').then(function(entries)
		{
			var groups = [];
			entries.forEach(function(entry)
			{
				var seedGroup = entry.seedGroup;
				if(seedGroup != null && !groups.includes(seedGroup))
				{
					groups.push(seedGroup);
				}
			});
			that.seedGroups = groups;
		});
	}
	
	@action
	seedGroupSelectionChanged(browserEvent)
	{
		this.selectedSeedGroup = browserEvent.target.value;
	}
	
	@action
	clear()
	{
		this.args.startImpulseSelectAction(null);
		this.selectedSeedGroup = null;
	}
	
	@action
	async associateWithEverySeedGroupEntry()
	{
		let seedGroup = this.selectedSeedGroup;
		let sSTR = this.args.selectedStartImpulse;
		
		if(seedGroup == null)
		{
			alert("no seed group selected");
			return;
		}
		if(sSTR == null)
		{
			alert("no start impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/seed-groups/"+seedGroup+"/associateAllWithStartTimingRecord/"+sSTR.id);
		
		if(response.error != null)
			alert(response.error);
		
		this.clear();
	}
	
	@action
	async associateWithUnassignedSeedGroupEntries()
	{
		let seedGroup = this.selectedSeedGroup;
		let sSTR = this.args.selectedStartImpulse;
		
		if(seedGroup == null)
		{
			alert("no seed group selected");
			return;
		}
		if(sSTR == null)
		{
			alert("no start impulse selected");
			return;
		}
		
		const response = await this.ajax.request("/seed-groups/"+seedGroup+"/associateUnassignedWithStartTimingRecord/"+sSTR.id);
		
		if(response.error != null)
			alert(response.error);
		
		this.clear();
	}
}
